'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// common chinese symbols: \u4e00-\u9eff - http://stackoverflow.com/a/1366113/837709
// hiragana (japanese): \u3040-\u309F - https://gist.github.com/ryanmcgrath/982242#file-japaneseregex-js
// katakana (japanese): \u30A0-\u30FF - https://gist.github.com/ryanmcgrath/982242#file-japaneseregex-js
// For an advanced explaination about Hangul see https://github.com/draft-js-plugins/draft-js-plugins/pull/480#issuecomment-254055437
// Hangul Syllables (korean): \uAC00-\uD7A3 - https://en.wikipedia.org/wiki/Korean_language_and_computers#Hangul_in_Unicode
// Hangul Jamo (korean): \u3130-\u318F - https://en.wikipedia.org/wiki/Korean_language_and_computers#Hangul_in_Unicode
exports.default = '[\\w\u4E00-\u9EFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7A3\u3130-\u318F]*';


//////////////////
// WEBPACK FOOTER
// ./assets/js-lib/draft-js-mention-plugin/defaultRegExp.js
// module id = 614
// module chunks = 0